/* @ngInject */
export default function disableLogging($logProvider, __env) {
    $logProvider.debugEnabled(__env.enableDebug);
}
